import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DateRange.css';
import React from 'react';
import { get } from '../../utils';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import { useHistory, useLocation } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import addQueryString, { removeQueryString } from './index';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var getFormatedDate = function getFormatedDate(date, lang) {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    // year: 'numeric',
    day: 'numeric',
    month: 'short'
  });
};
export var eventDatesRange = 'datesRange';
/*eslint-disable */

var DateRange = function DateRange(_ref) {
  var fields = _ref.fields,
    hideLabel = _ref.hideLabel,
    showButtonColor = _ref.showButtonColor,
    pickDate = _ref.pickDate,
    showLabel = _ref.showLabel,
    fullWidth = _ref.fullWidth,
    resultsLabel = _ref.resultsLabel,
    buttonYellow = _ref.buttonYellow,
    buttonBlue = _ref.buttonBlue,
    clearAllLabel = _ref.clearAllLabel,
    onChangeCallback = _ref.onChangeCallback,
    onToggleCallback = _ref.onToggleCallback,
    ignoreQueryString = _ref.ignoreQueryString,
    clearWithCloseWrapper = _ref.clearWithCloseWrapper,
    setFilter = _ref.setFilter,
    innerHeightAuto = _ref.innerHeightAuto,
    widgetAnalytics = _ref.widgetAnalytics,
    facetsName = _ref.facetsName,
    wrapperToggle = _ref.wrapperToggle,
    setSubpanelLabel = _ref.setSubpanelLabel,
    clearAlllFilters = _ref.clearAlllFilters,
    lang = _ref.lang,
    analytics = _ref.analytics,
    _ref$clearAllCallback = _ref.clearAllCallback,
    clearAllCallback = _ref$clearAllCallback === void 0 ? function () {} : _ref$clearAllCallback,
    setStartPage = _ref.setStartPage,
    _ref$submenuHelper = _ref.submenuHelper,
    submenuHelper = _ref$submenuHelper === void 0 ? false : _ref$submenuHelper,
    getFilterValue = _ref.getFilterValue,
    primaryColor = _ref.primaryColor,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-4' : _ref$columnsClass,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    dateRangeValue = _ref.dateRangeValue,
    getDateRangeValue = _ref.getDateRangeValue,
    _ref$withMapConfig = _ref.withMapConfig,
    withMapConfig = _ref$withMapConfig === void 0 ? false : _ref$withMapConfig;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var queries = queryParams["".concat(eventDatesRange)];
  var _facetsName = _slicedToArray(facetsName, 2),
    dateFromFieldName = _facetsName[0],
    dateToFieldName = _facetsName[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setisOpen = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    date = _React$useState4[0],
    setdate = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    dateInit = _React$useState6[0],
    setDateInit = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    formattedDate = _React$useState8[0],
    setFormattedDate = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    filterApplied = _React$useState10[0],
    setfilterApplied = _React$useState10[1];
  //const isOpen = false;
  var label = get(fields, 'title.jss.value');
  var type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Date' ? 'single' : 'range';
  // const clearAllLabel = 'clearAllLabel';
  var history = useHistory();
  var filterName = get(fields, 'name');
  var labelToId = (label || '').trim().replace(/\s+/g, '-').toLowerCase();
  var selectedPrimaryColor = primaryColor ? primaryColor : 'var(--main-color)';
  var variables = {
    '--date-range-primary-color': buttonYellow ? 'var(--events-widget-primary-color)' : selectedPrimaryColor
  };
  var fp = /*#__PURE__*/React.createRef();
  React.useEffect(function () {
    if (withMapConfig) {
      var _date = dateRangeValue.date,
        _dateInit = dateRangeValue.dateInit,
        _formattedDate = dateRangeValue.formattedDate;
      setDateInit(_dateInit);
      setFormattedDate(_formattedDate ? _formattedDate : label);
      setdate(_date);
    }
  }, [dateRangeValue]);
  React.useEffect(function () {
    toggleFilter(!submenuHelper, false);
    getFilterValue && getFilterValue(fields.name, eventDatesRange, date);
    // if(!submenuHelper) {
    // 	submitFilters();
    // }
  }, [submenuHelper]);
  var toggleFilter = function toggleFilter(open) {
    var closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setisOpen(!open);
    wrapperToggle(open, closePanel);
    setSubpanelLabel(label);
    if (setStartPage) {
      setStartPage(true);
    }
  };
  var clearFilter = function clearFilter(e) {
    setdate('');
    setDateInit([]);
    setFormattedDate('');
    if (setStartPage) {
      setStartPage(isOpen);
    }
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
    setisOpen(false);
    if (clearWithCloseWrapper) {
      wrapperToggle(true);
    }
    setfilterApplied(false);

    // if(clearAllCallback) {
    //   clearAllCallback()
    // }
    if (!ignoreQueryString) {
      removeQueryString(eventDatesRange, history);
    }
    setFilter('', 'daterange', '');
    getFilterValue && getFilterValue(fields.name, eventDatesRange, null);
    if (withMapConfig && getDateRangeValue) {
      getDateRangeValue({
        date: '',
        dateInit: undefined,
        formattedDate: ''
      });
    }
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(function () {
    if (clearAlllFilters) {
      clearFilter();
    }
  }, [clearAlllFilters]);
  var submitFilters = function submitFilters(e) {
    setisOpen(false);
    setfilterApplied(true);
    setFilter(date, 'daterange', dateInit);
    if (!ignoreQueryString) {
      addQueryString(eventDatesRange, date, history);
    }
    getFilterValue && getFilterValue(fields.name, eventDatesRange, date);
    if (e) {
      e.stopPropagation();
    }
  };
  var closeDropdwn = function closeDropdwn(event) {
    if (event.target.closest) {
      if (!event.target.closest('.filter__field') && !event.target.closest('.filter__header')) {
        setisOpen(false);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
      }
    } else {
      setisOpen(false);
    }
  };
  React.useEffect(function () {
    document.body.addEventListener('click', closeDropdwn);
    return function () {
      if (!withMapModalView) {
        if (!ignoreQueryString) {
          removeQueryString(eventDatesRange, history);
        }
      }
    };
  }, []);
  var currentLocale = function currentLocale(lang) {
    if (lang === 'ar') {
      return Arabic;
    }
    if (lang === 'ru') {
      return Russian;
    }
    if (lang === 'cs') {
      return Czech;
    }
    if (lang === 'nl') {
      return Dutch;
    }
    if (lang === 'fi') {
      return Finnish;
    }
    if (lang === 'de') {
      return German;
    }
    if (lang === 'ja') {
      return Japanese;
    }
    if (lang === 'no') {
      return Norwegian;
    }
    if (lang === 'pt') {
      return Portuguese;
    }
    if (lang === 'sv') {
      return Swedish;
    }
    if (lang === 'zh') {
      return Mandarin;
    }
    if (lang === 'da') {
      return Danish;
    }
    if (lang === 'fr') {
      return French;
    }
    if (lang === 'it') {
      return Italian;
    }
    if (lang === 'ko') {
      return Korean;
    }
    if (lang === 'pl') {
      return Polish;
    }
    if (lang === 'ro') {
      return Romanian;
    }
    if (lang === 'es') {
      return Spanish;
    }
    if (lang === 'uk') {
      return Ukrainian;
    }
    if (lang === 'tr') {
      return Turkish;
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fullWidth: fullWidth,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-filter d-none"
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "filter__field date-range",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(event) {
      onToggleCallback && onToggleCallback();
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (event.target.closest && !event.target.closest('.filter-panel__inner')) {
        toggleFilter(isOpen);
      }
      var classList = event.target.classList;
      var value;
      if (classList.contains('flatpickr-prev-month')) {
        value = 'Navigate Left';
      }
      if (classList.contains('flatpickr-next-month')) {
        value = 'Navigate Right';
      }
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterSelectDateAnalytics, analytics.params), value);
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        onToggleCallback && onToggleCallback();
        if (setStartPage) {
          setStartPage(isOpen);
        }
        if (event.target.closest && !event.target.closest('.filter-panel__inner')) {
          toggleFilter(isOpen);
        }
        var classList = event.target.classList;
        var value;
        if (classList.contains('flatpickr-prev-month')) {
          value = 'Navigate Left';
        }
        if (classList.contains('flatpickr-next-month')) {
          value = 'Navigate Right';
        }
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterSelectDateAnalytics, analytics.params), value);
      }
    },
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : '')
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, formattedDate ? formattedDate : label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner ".concat(innerHeightAuto ? 'filter-panel__inner-auto' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear btn--reset",
    onClick: function onClick(e) {
      setFilter("type:\"Event\"", 'daterange', dateInit);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
      clearFilter(e);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        setFilter("type:\"Event\"", 'daterange', dateInit);
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
        clearFilter(e);
      }
    }
  }, clearAllLabel)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": labelToId,
    value: dateInit,
    options: {
      mode: type,
      minDate: 'today',
      inline: true,
      locale: lang === 'en' ? 'en' : currentLocale(lang),
      nextArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><path fill=\"currentColor\" d=\"M7.712 4a2.14 2.14 0 01-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z\"/></svg>",
      prevArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><path fill=\"currentColor\" d=\"M7.712 4a2.14 2.14 0 01-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z\"/></svg>"
    },
    onChange: function onChange(date, dateStr, instance) {
      if (date && date.length !== 0) {
        onChangeCallback && onChangeCallback();
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, ": ").concat(formatDate(date)));
        setDateInit(date);
        var date0Temp = new Date(date[0]);
        var userTimezoneOffset = date0Temp.getTimezoneOffset() * 60000;
        var date0 = new Date(date0Temp.getTime() - userTimezoneOffset).toString();
        if (date[1]) {
          var date1Temp = new Date(date[1]);
          var userTimezoneOffset1 = date1Temp.getTimezoneOffset() * 60000;
          var date1 = new Date(date1Temp.getTime() - userTimezoneOffset1).toString();
          setdate("(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000, " AND ").concat(dateFromFieldName, " <= ").concat(Date.parse(date1) / 1000, ")"));
          setFormattedDate("".concat([getFormatedDate(date[0], lang) + ' - ' + getFormatedDate(date[1], lang)]));
          if (withMapConfig && getDateRangeValue) {
            getDateRangeValue({
              date: "(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000, " AND ").concat(dateFromFieldName, " <= ").concat(Date.parse(date1) / 1000, ")"),
              dateInit: date ? date : undefined,
              formattedDate: "".concat([getFormatedDate(date[0], lang) + ' - ' + getFormatedDate(date[1], lang)])
            });
          }
        } else {
          setdate("(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000 - 86400, " AND ").concat(dateFromFieldName, " <= ").concat(Date.parse(date0) / 1000 + 86400, ")"));
          if (withMapConfig && getDateRangeValue) {
            getDateRangeValue({
              date: "(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000 - 86400, " AND ").concat(dateFromFieldName, " <= ").concat(Date.parse(date0) / 1000 + 86400, ")"),
              dateInit: date ? date : undefined,
              formattedDate: getFormatedDate(date[0], lang)
            });
          }
          setFormattedDate(getFormatedDate(date[0], lang));
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    style: showButtonColor ? {
      backgroundColor: showButtonColor
    } : {},
    onClick: function onClick(e) {
      wrapperToggle(true);
      submitFilters(e);
      !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
    }
  }, pickDate ? pickDate : "".concat(showLabel, " ").concat(resultsLabel)))))));
};
function formatDate(dateArr) {
  var _dateArr = _slicedToArray(dateArr, 2),
    date1 = _dateArr[0],
    date2 = _dateArr[1];
  var format = function format(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();
    return (d <= 9 ? '0' + d : d) + '/' + (m <= 9 ? '0' + m : m) + '/' + y;
  };
  return "".concat(format(date1)).concat(date2 ? " - ".concat(format(date2)) : '');
}
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    fullWidth = _ref2.fullWidth,
    columnsClass = _ref2.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(fullWidth ? '' : columnsClass)
  }, children);
};
// export default DateRange;
export default DateRange;
export var commonStyles = "c1lpxz1e";
/*eslint-disable */